import _ from "lodash";
import React, { forwardRef } from "react";
import { getImage } from "../Utils";
import classNames from "classnames";
import classes from "./SearchItem.scss";
import { Avatar } from "@toddle-edu/ds-web";
import { BoldMatch } from "Utils";

export const SearchItem = forwardRef((props, ref) => {
  const { id, item, onSelectItem, searchText } = props;
  const {
    title,
    subTitle,
    type,
    imageUrl,
    metadata,
    curriculumIndicatorData,
  } = item;

  const imageByType = getImage({ type, metadata });
  return (
    <div
      data-elm="search-item"
      className={classes.container}
      role="button"
      tabIndex="-1"
      onClick={e => {
        onSelectItem({ item, e });
      }}
    >
      <div className={classes.imageContainerWrapper}>
        {imageByType ? (
          <div className={classes.imageContainer}>{imageByType}</div>
        ) : (
          <Avatar
            size="small"
            shade="light"
            shape="square"
            name={title}
            src={imageUrl}
            className={classes.profileImageContainer}
          />
        )}
      </div>
      <div className={classes.searchItemLabelContainer} style={{ gap: "2px" }}>
        <div
          className={classNames({
            [classes.title]: true,
            "text-body": true,
          })}
        >
          <div>
            <BoldMatch text={title} match={searchText} />
          </div>
        </div>
        {subTitle || !_.isEmpty(curriculumIndicatorData) ? (
          <div
            className={classNames({
              [classes.subtitle]: true,
              "text-body-s": true,
            })}
          >
            {_.get(curriculumIndicatorData, "acronym") && (
              <div className={classes.curriculumIndicatorText}>
                {`${_.get(curriculumIndicatorData, "acronym")} / `}
              </div>
            )}
            <div>
              <BoldMatch text={subTitle} match={searchText} />
            </div>
          </div>
        ) : null}
      </div>
    </div>
  );
});
SearchItem.displayName = "SearchItem";
